import {
  generateActions,
  generateSelectors,
  generateTypes,
  generateAction,
  generateSelector,
  generateType,
} from "../util";

export const key = "models";

// update model
export const UPDATE_MODEL = generateTypes(key, "update");
export const [
  updateExistingModel,
  updateExistingModelSuccess,
  updateExistingModelError,
  updateExistingModelBusy,
  updateExistingModelPoll,
] = generateActions(UPDATE_MODEL);
export const [
  selectExistingModel,
  selectExistingModelError,
  selectExistingModelBusy,
  selectExistingModelPoll,
  selectExistingModelRequest,
] = generateSelectors(UPDATE_MODEL);

//duplicate model
export const DUPLICATE_MODEL = generateTypes(key, "duplicate");
export const [duplicateModel, duplicateModelSuccess, duplicateModelError, duplicateModelBusy, duplicateModelPoll] =
  generateActions(DUPLICATE_MODEL);
export const [
  selectDuplicateModel,
  selectDuplicateModelError,
  selectDuplicateModelBusy,
  selectDuplicateModelPoll,
  selectDuplicateModelRequest,
] = generateSelectors(DUPLICATE_MODEL);

// delete model
export const DELETE_MODEL = generateTypes(key, "remove");
export const [deleteExistingModel, deleteExistingModelSuccess, deleteExistingModelError, deleteExistingModelBusy] =
  generateActions(DELETE_MODEL);
export const [
  selectDeleteExistingModel,
  selectDeleteExistingModelError,
  selectDeleteExistingModelBusy,
  selectDeleteExistingModelRequest,
] = generateSelectors(DELETE_MODEL);

// read models
export const READ_MODELS = generateTypes(key, "read");
export const [readAllModels, readAllModelsSuccess, readAllModelsError, readAllModelsBusy, readAllModelsPoll] =
  generateActions(READ_MODELS);
export const [selectReadAllModels, selectReadAllModelsError, selectReadAllModelsBusy, , selectReadAllModelsRequest] =
  generateSelectors(READ_MODELS);

// catalog models
export const CATALOG_MODELS = generateTypes(key, "catalog");
export const [catalogModels, catalogModelsSuccess, catalogModelsError, catalogModelsBusy] =
  generateActions(CATALOG_MODELS);
export const [selectCatalogModels, selectCatalogModelsError, selectCatalogModelsBusy, , selectCatalogModelsRequest] =
  generateSelectors(CATALOG_MODELS);

// read existing model
export const READ_A_MODEL = generateTypes(key, "read-one");
export const [readExistingModel, readExistingModelSuccess, readExistingModelError, readExistingModelBusy] =
  generateActions(READ_A_MODEL);
export const [
  selectReadExistingModel,
  selectReadExistingModelError,
  selectReadExistingModelBusy,
  ,
  selectReadExistingModelRequest,
] = generateSelectors(READ_A_MODEL);

// run model
export const RUN_MODEL = generateTypes(key, "run");
export const [runExistingModel, runExistingModelSuccess, runExistingModelError, runExistingModelBusy] =
  generateActions(RUN_MODEL);
export const [
  selectRunExistingModel,
  selectRunExistingModelError,
  selectRunExistingModelBusy,
  ,
  selectRunExistingModelRequest,
] = generateSelectors(RUN_MODEL);

// stop model
export const STOP_MODEL = generateTypes(key, "stop");
export const [stopModel, stopModelSuccess, stopModelError, stopModelBusy] = generateActions(STOP_MODEL);
export const [selectStopModel, selectStopModelError, selectStopModelBusy, , selectStopModelRequest] =
  generateSelectors(STOP_MODEL);

// get model progress
export const PROGRESS = generateTypes(key, "progress");
export const [
  getModelProgress,
  getModelProgressSuccess,
  getModelProgressError,
  getModelProgressBusy,
  getModelProgressPoll,
] = generateActions(PROGRESS);
export const [selectModelProgress, selectModelProgressError, selectModelProgressBusy, , selectModelProgressRequest] =
  generateSelectors(PROGRESS);

// share model
export const SHARE_MODEL = generateTypes(key, "share");
export const [shareModel, shareModelSuccess, shareModelError, shareModelBusy, shareModelPoll] =
  generateActions(SHARE_MODEL);
export const [
  selectShareModel,
  selectShareModelError,
  selectShareModelBusy,
  selectShareModelPoll,
  selectShareModelRequest,
] = generateSelectors(SHARE_MODEL);

export const READ_MODEL_SHARES = generateTypes(key, "read_shares");
export const [
  readModelShares,
  readModelSharesSuccess,
  readModelSharesError,
  readModelSharesBusy,
  readModelSharesPoll,
] = generateActions(READ_MODEL_SHARES);
export const [
  selectReadModelShares,
  selectReadModelSharesError,
  selectReadModelSharesBusy,
  selectReadModelSharesPoll,
  selectReadModelSharesRequest,
] = generateSelectors(READ_MODEL_SHARES);

export const REVOKE_MODEL_SHARE = generateTypes(key, "revoke_share");
export const [
  revokeModelShare,
  revokeModelShareSuccess,
  revokeModelShareError,
  revokeModelShareBusy,
  revokeModelSharePoll,
] = generateActions(REVOKE_MODEL_SHARE);
export const [
  selectRevokeModelShare,
  selectRevokeModelShareError,
  selectRevokeModelShareBusy,
  selectRevokeModelSharePoll,
  selectRevokeModelShareRequest,
] = generateSelectors(REVOKE_MODEL_SHARE);

// selected models
export const SELECTED_MODELS = generateType(key, "selected-models");
export const setSelectedModels = generateAction(SELECTED_MODELS);
export const selectSelectedModels = generateSelector(key, SELECTED_MODELS);

// stored model inputs
export const STORED_MODEL_INPUTS = generateType(key, "stored-model-inputs");
export const setStoredModelInput = generateAction(STORED_MODEL_INPUTS);
export const selectStoredModelInputs = generateSelector(key, STORED_MODEL_INPUTS);
export const STORED_MODEL_INPUTS_STORAGE_KEY = "models.storedModelInputs";

// ai changed input paths
export const AI_CHANGED_INPUT_PATHS = generateType(key, "ai-changed-input-paths");
export const setAiChangedInputPaths = generateAction(AI_CHANGED_INPUT_PATHS);
export const selectAiChangedInputPaths = generateSelector(key, AI_CHANGED_INPUT_PATHS);
export const AI_CHANGED_INPUT_PATHS_STORAGE_KEY = "models.aiChangedInputPaths";

// apply AI-driven model input change (client-side only)
export const APPLY_AI_MODEL_INPUT_CHANGE = generateType(key, "apply-ai-model-input-change");
export const applyAiModelInputChange = generateAction(APPLY_AI_MODEL_INPUT_CHANGE);

// persist model diffs
export const PERSIST_MODEL_DIFF_STATE = generateType(key, "persist-model-diff-state");
export const persistModelDiffState = generateAction(PERSIST_MODEL_DIFF_STATE);

// unsaved model inputs
export const UNSAVED_MODEL_INPUTS = generateType(key, "unsaved-model-inputs");
export const setUnsavedModelInput = generateAction(UNSAVED_MODEL_INPUTS);
export const selectUnsavedModelInputs = generateSelector(key, UNSAVED_MODEL_INPUTS);
